import { render } from "./Remarks.vue?vue&type=template&id=3333e242&ts=true"
import script from "./Remarks.vue?vue&type=script&lang=ts"
export * from "./Remarks.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__